import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ConfirmService } from './confirm.service';
import { Confirm } from './../shared/models';

declare const moment: any;

@Component({
  selector: 'confirm',
  template: require('./confirm.component.html'),
  styles: [require('./confirm.component.scss')],
  providers: [ConfirmService]
})
export class ConfirmComponent implements OnInit {
  sub: any;
  code: string = '';

  constructor(private service: ConfirmService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['code'] !== null && params['code'] !== undefined) {
        this.code = params['code'];
      }

      if (this.service.type !== 'no-email') {
        this.service.checkIfUser(this.service.app.email);
      }
    });
  }

  confirmEmail() {
    this.service.frontError = false;
    this.service.validateEmail();

    if (!this.service.frontError) {
      let model = new Confirm(this.service.email, this.code);
      this.service.confirm(model);
    }
  }

  reset() {
    this.service.frontError = false;
    this.service.validatePassword();

    if (!this.service.frontError) {
      this.service.reset(this.service.email, this.code, this.service.password);
    }
  }

  login() {
    this.close();
    this.service.app.toggleLogin();
  }

  close() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/confirm/confirm.component.ts